import { type Components, type Theme, alpha } from '@mui/material';

import { colors, opacity } from '@verantos-dev/shared-ui-components/tokens';

const buttonBaseThemeConfig: Components<Theme>['MuiButtonBase'] = {
  defaultProps: {
    disableRipple: true,
  },
};

const buttonThemeConfig: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    sizeSmall: { height: '30px', fontSize: '13px' },
    sizeMedium: { height: '36px', fontSize: '14px' },
    sizeLarge: { height: '42px', fontSize: '15px' },

    containedPrimary: {
      backgroundColor: colors['primary-500'],
      textTransform: 'none',
      color: colors.white,
      fontSize: 15,
      fontWeight: 500,
      letterSpacing: '0.46px',
      whiteSpace: 'nowrap',
      '&:hover': {
        // TODO: no VDS token for this value (#00256c) — needs designer input (Barry Richardson)
        backgroundColor: '#00256c',
      },
      '&:focus': {
        backgroundColor: colors['primary-500'],
        outline: `${colors['secondary-500']} solid 2px`,

        '&:hover': {
          // TODO: no VDS token for this value (#00256c) — needs designer input (Barry Richardson)
          backgroundColor: '#00256c',
        },
      },
      '&:disabled': {
        // TODO: no VDS token for pure black (#000000) — needs designer input (Barry Richardson)
        backgroundColor: alpha('#000000', opacity[12]),
        color: alpha('#000000', opacity[38]),
      },
    },
    containedSecondary: {
      backgroundColor: colors.white,
      textTransform: 'none',
      border: `1px solid ${colors['primary-500']}`,
      boxShadow: 'none',
      color: colors['primary-500'],
      fontSize: 15,
      fontWeight: 500,
      whiteSpace: 'nowrap',

      '&:hover': {
        // TODO: no VDS token for this value (#ccf0f9) — needs designer input (Barry Richardson)
        backgroundColor: '#ccf0f9',
      },
      '&:focus': {
        backgroundColor: colors.white,
        borderColor: colors['secondary-500'],
        // TODO: no VDS token for this value (#0085b0) — needs designer input (Barry Richardson)
        color: '#0085b0',
        outline: `${colors['secondary-500']} solid 2px`,

        '&:hover': {
          // TODO: no VDS token for this value (#ccf0f9) — needs designer input (Barry Richardson)
          backgroundColor: '#ccf0f9',
          borderColor: colors['secondary-500'],
          // TODO: no VDS token for this value (#0085b0) — needs designer input (Barry Richardson)
          color: '#0085b0',
        },
      },
      '&:disabled': {
        // TODO: no VDS token for pure black (#000000) — needs designer input (Barry Richardson)
        backgroundColor: alpha('#000000', opacity[12]),
        color: alpha('#000000', opacity[38]),
        border: 'none',
      },
    },
    containedError: {
      // TODO: no VDS token for this value (#D42828) — needs designer input (Barry Richardson)
      backgroundColor: '#D42828',
      textTransform: 'none',
      border: 'none',
      color: colors.white,
      fontSize: 15,
      fontWeight: 500,
      whiteSpace: 'nowrap',

      '&:hover': {
        // TODO: no VDS token for this value (#9b0000) — needs designer input (Barry Richardson)
        backgroundColor: '#9b0000',
      },
      '&:focus': {
        // TODO: no VDS token for this value (#d42828) — needs designer input (Barry Richardson)
        backgroundColor: '#d42828',
        borderColor: colors['secondary-500'],
        color: colors.white,
        outline: `${colors['secondary-500']} solid 2px`,

        '&:hover': {
          // TODO: no VDS token for this value (#9b0000) — needs designer input (Barry Richardson)
          backgroundColor: '#9b0000',
        },
      },
      '&:disabled': {
        // TODO: no VDS token for pure black (#000000) — needs designer input (Barry Richardson)
        backgroundColor: alpha('#000000', opacity[12]),
        color: alpha('#000000', opacity[38]),
      },
    },
    // text button
    containedInfo: {
      backgroundColor: 'transparent',
      textTransform: 'none',
      border: 'none',
      // TODO: no VDS token for pure black (#000000) or opacity 0.87 — needs designer input (Barry Richardson)
      color: alpha('#000000', 0.87),
      fontSize: 15,
      fontWeight: 500,
      boxShadow: 'none',
      whiteSpace: 'nowrap',

      '&:hover': {
        backgroundColor: colors['neutral-100'],
        textDecoration: 'underline',
      },
      '&:focus': {
        backgroundColor: colors['neutral-100'],
        // TODO: no VDS token for pure black (#000) — needs designer input (Barry Richardson)
        color: '#000',
        outline: `${colors['secondary-500']} solid 2px`,

        '&:hover': {
          backgroundColor: colors['neutral-100'],
          textDecoration: 'underline',
        },
      },

      '&:disabled': {
        backgroundColor: colors['neutral-100'],
        // TODO: no VDS token for pure black (#000) — needs designer input (Barry Richardson)
        color: '#000',
        opacity: 0.6,
      },
    },
  },
};

export const muiButtonThemeConfig = {
  MuiButton: {
    ...buttonThemeConfig,
  },
  MuiButtonBase: {
    ...buttonBaseThemeConfig,
  },
};
